<div class="instructores-container">
  <div class="global-search">
    <header>
      <div class="title-group">
        <h1>Instructores</h1>
        <h2>Filtros de busqueda</h2>
      </div>
    </header>
    <div>
      <label for="searchNroLibreta">Numero de libreta:</label>
      <input id="searchNroLibreta" type="number" [(ngModel)]="searchNroLibreta" (input)="filterInstructores()">
    </div>
    <div>
      <label for="searchNombre">Nombre:</label>
      <input id="searchNombre" type="text" [(ngModel)]="searchNombre" (input)="filterInstructores()">
    </div>
    <div>
      <label for="searchApellido">Apellido:</label>
      <input id="searchApellido" type="text" [(ngModel)]="searchApellido" (input)="filterInstructores()">
    </div>
    <div class="search-controls-row">
      <div>
        <label for="activos">Activos:</label>
        <input id="activos" type="checkbox" [(ngModel)]="activos" (change)="onActivosChange()">
      </div>
      <div>
        <label for="inactivos">Inactivos:</label>
        <input id="inactivos" type="checkbox" [(ngModel)]="inactivos" (change)="onInactivosChange()">
      </div>
      <div>
        <label for="orderBy">Ordenar por:</label>
        <select id="orderBy" [(ngModel)]="orderBy" (change)="filterInstructores()">
          <option value="nroLibreta">N° de libreta</option>
          <option value="nombre">Nombre</option>
          <option value="apellido">Apellido</option>
          <option value="graduacion">Graduación</option>
        </select>
        <select id="orderDirection" [(ngModel)]="orderDirection" (change)="filterInstructores()">
          <option value="asc">Asc</option>
          <option value="desc">Des</option>
        </select>
      </div>
    </div>
    <div class="buttons-container">
      <button (click)="clearFilters()" title="Limpiar filtros" aria-label="Clear Filters">
        <i class="fas fa-eraser"></i>
      </button>
    </div>
  </div>
  <div class="global-results">
    <header>
      <div class="title-group">
        <h1>Resultados</h1>
      </div>
      <div (click)="addInstructor()" class="new-button" title="Agregar instructor" aria-label="Add Instructor">
        <i class="fas fa-plus"></i> Nuevo
      </div>  
    </header>
    <app-popup *ngIf="showPopup" [title]="'Instructor guardado'" [data]="savedData" (close)="closePopup()"></app-popup>
    <ul>
      <li *ngFor="let instructor of filteredInstructores" class="card">
        <div class="info">
          <div class="nroLibreta-search" *ngIf="instructor.isEditMode || !instructor.disableValidation">
            <label for="">Numero de libreta:</label>
            <input
              [(ngModel)]="instructor.nroLibreta"
              [disabled]="!instructor.isEditMode"
              (change)="onNroLibretaChange(instructor)"
              (keypress)="onNroLibretaKeyPress($event, instructor)"
              type="number"
              placeholder="Presiona Enter para buscar"/>
            <button *ngIf="instructor.isEditMode" (click)="buscarEstudiante(instructor)" title="Buscar">
              <i class="fas fa-search"></i>
            </button>
          </div>
          <div *ngIf="instructor.isEditMode || !instructor.disableValidation">
            <label for="">Nombre:</label>
            <input [(ngModel)]="instructor.nombre" [disabled]="instructor.nroLibreta !== 0 || !instructor.isEditMode" type="text">
          </div>
          <div *ngIf="instructor.isEditMode || !instructor.disableValidation">
            <label for="">Apellido:</label>
            <input [(ngModel)]="instructor.apellido" [disabled]="instructor.nroLibreta !== 0 || !instructor.isEditMode" type="text">
          </div>
          <div *ngIf="instructor.isEditMode || !instructor.disableValidation">
            <label for="">Activo:</label>
            <input type="checkbox" [(ngModel)]="instructor.activo" [disabled]="!instructor.isEditMode">
          </div>
          <div class="info" style="width: 100%;">
            <div *ngIf="instructor.graduacion">
              <label for="">Graduación:</label>
              <input type="text" [disabled]="true" value="{{ instructor.graduacion.nombre }}"/>
            </div>
            <div *ngIf="instructor.email">
              <label for="">Correo electronico:</label>
              <input style="max-width: 300px;" type="text" [disabled]="true" value="{{ instructor.email }}"/>
            </div>
          </div>
        </div>
        <div class="buttons-container">
          <button *ngIf="!instructor.isEditMode" class="edit-button" (click)="toggleEditMode(instructor)" title="Editar" aria-label="Edit">
            <i class="fas fa-pencil-alt"></i>
          </button>
          <button *ngIf="instructor.isEditMode" (click)="guardar(instructor)" [disabled]="isNroLibretaDuplicated || errorMessages[instructor.id]" title="Guardar" aria-label="Save">
            <i class="fas fa-save"></i>
          </button>
          <button class="cancel-btn" *ngIf="instructor.isEditMode" (click)="cancelar(instructor)" title="Cancelar" aria-label="Cancel">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div *ngIf="errorMessages[instructor.id]" class="error-message">{{ errorMessages[instructor.id] }}</div>
      </li>
    </ul>
  </div>
</div>